module.exports = "../dist/img/white-26.fd9d.jpg";